import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, cancelSubscriptionPlanApi, createCheckoutSessionApi, createCheckoutSessionOneTimeApi, getAllSubscriptionPlansApi } from "../utils/Constants";

// Helper function for config
const getAuthConfig = () => ({
  headers: {
    Authorization: localStorage.getItem("token"),
  },
});

// Fetch subscriptionPlan list
export const getSubscriptionPlanList = createAsyncThunk(
  "subscriptionPlan/getAll",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        ApiBaseUrl + getAllSubscriptionPlansApi,
        getAuthConfig()
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message ||
          "Failed to fetch subscriptionPlan list."
      );
    }
  }
);

export const createCheckoutSession = createAsyncThunk(
  "subscriptionPlan/subscribe/session",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        ApiBaseUrl + createCheckoutSessionApi,
        payload,
        getAuthConfig()
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message ||
          "Failed to fetch subscriptionPlan list."
      );
    }
  }
);

export const cancelSubscription = createAsyncThunk(
  "subscriptionPlan/subscribe/cancel",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        ApiBaseUrl + cancelSubscriptionPlanApi,
        payload,
        getAuthConfig()
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message ||
          "Failed to fetch subscriptionPlan list."
      );
    }
  }
);

export const createCheckoutSessionForOneTimePayment = createAsyncThunk(
  "subscriptionPlan/subscribe/session/one/time",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        ApiBaseUrl + createCheckoutSessionOneTimeApi,
        payload,
        getAuthConfig()
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message ||
          "Failed to fetch subscriptionPlan list."
      );
    }
  }
);

const subscriptionPlanSlice = createSlice({
  name: "subscriptionPlan",
  initialState: {
    subscriptionPlans: [],
    subscriptionSession: {},
    isLoading: false,
    isError: false,
    errorMessage: null,
  },
  reducers: {
    clearSubscriptionPlanData: (state) => {
      state.subscriptionPlans = [];
      state.isError = false;
      state.errorMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Get
      .addCase(getSubscriptionPlanList.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = null;
      })
      .addCase(getSubscriptionPlanList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.subscriptionPlans = action.payload.data;
      })
      .addCase(getSubscriptionPlanList.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })

      .addCase(createCheckoutSession.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = null;
      })
      .addCase(createCheckoutSession.fulfilled, (state, action) => {
        state.isLoading = false;
        state.subscriptionSession = action.payload.data;
      })
      .addCase(createCheckoutSession.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })

      .addCase(createCheckoutSessionForOneTimePayment.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = null;
      })
      .addCase(createCheckoutSessionForOneTimePayment.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(createCheckoutSessionForOneTimePayment.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })

      .addCase(cancelSubscription.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = null;
      })
      .addCase(cancelSubscription.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(cancelSubscription.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })

  },
});

export const { clearSubscriptionPlanData } = subscriptionPlanSlice.actions;
export default subscriptionPlanSlice.reducer;
